import apiDealerPartService from "@/services/api/modules/dealerPartService";
import { DUMMY_GET_MASTERLIST_API_RESPONSE } from "../../statics";

export default {
  async getInventories({ commit, dispatch }, params = {}) {
    commit("SET_INVENTORIES", []);
    const { status, data } = await apiDealerPartService.getInventories(params);

    if (status !== 200) {
      dispatch(
        "snackbar/show",
        {
          text: data.message,
          timeout: 10000,
        },
        {
          root: true,
        }
      );

      /**
       * only for testing
       */
      commit("SET_INVENTORIES", DUMMY_GET_MASTERLIST_API_RESPONSE);
    } else {
      
      let responseData = Object.keys(params).length === 0 ? data.data : data;

      commit("SET_INVENTORIES", responseData);
    }
  },

  async uploadInventories({ commit, dispatch }, file) {
    const { status, data } = await apiDealerPartService.uploadInventories(file);
    const message = data.errors ? Object.values(data.errors).join(" ") : data.message;

    dispatch(
      "snackbar/show",
      {
        text: message,
        timeout: 10000,
      },
      {
        root: true,
      }
    );

    return data.success;
  },

  async getInventory({ commit, dispatch }, id) {
    commit("SET_INVENTORY", []);
    const { status, data } = await apiDealerPartService.getInventory(id);

    if (status !== 200) {
      dispatch(
        "snackbar/show",
        {
          text: data.message,
          timeout: 10000,
        },
        {
          root: true,
        }
      );

      /**
       * only for testing
       */
      commit("SET_INVENTORY", DUMMY_GET_MASTERLIST_API_RESPONSE.data[0]);
    } else {
      
      commit("SET_INVENTORY", data.data);
    }
  },
};
